import { Scan, Finding } from '@/types'

const useScanReport = () => {
  const checkCopy = (finding: Finding) => {
    return {
      groupTitle: finding.subCategory,
      label: finding.name,
      description: finding.message || finding.description,
    }
  }

  const buildReport = (scan: Scan, excludedCategories: string[] = []) => {
    const { findings } = scan
    const report: any = {}
    const excludedCategoriesList = [...excludedCategories]
    report.findings = findings
      .filter(finding => !excludedCategoriesList.includes(finding.key))
      .map(finding => {
        return {
          ...finding,
          ...checkCopy(finding),
          category: finding.category,
          subCategory: finding.subCategory,
        }
      })
    return report
  }

  return { buildReport }
}

export default useScanReport
